<template>
    <div>
      <div style="margin:auto;text-align:center" :style="!$vuetify.breakpoint.smAndDown ? 'width: 50%;' : 'width: 100%;'">
        <div v-if="!$vuetify.breakpoint.smAndDown">
          <v-btn dark small color="#1f97b9" @click="previous()">
            <v-icon dark>fas fa-angle-left</v-icon>
          </v-btn>
          <input v-model.number="page" type="number" style="width: 30px" :max="numPages" :min="1"> /{{numPages}}
          <v-btn dark small color="#1f97b9" @click="next()">
            <v-icon dark>fas fa-angle-right</v-icon>
          </v-btn>
        </div>
        <div v-if="loadedRatio > 0 && loadedRatio < 1" style="background-color: green; color: white; text-align: center" :style="{ width: loadedRatio * 100 + '%' }">{{ Math.floor(loadedRatio * 100) }}%</div>
        <pdf v-if="terminosCliente" ref="pdf" style="border: 1px solid grey; width:100%;" :src="terminosCliente" :page="page" :rotate="rotate" @progress="loadedRatio = $event" @num-pages="numPages = $event" @link-clicked="page = $event"></pdf>
        <v-btn dark small color="#1f97b9" @click="previous()">
          <v-icon dark>fas fa-angle-left</v-icon>
        </v-btn>
        <input v-model.number="page" type="number" style="width: 30px" :max="numPages" :min="1"> /{{numPages}}
        <v-btn dark small color="#1f97b9" @click="next()">
          <v-icon dark>fas fa-angle-right</v-icon>
        </v-btn>
      </div>
    </div>
</template>
<script>
import pdf from 'vue-pdf'
import * as firebase from 'firebase/app'
import 'firebase/firestore'
export default {
    components: {
        pdf: pdf
    },
    mounted (){
      this.get_mantenedores()
    },
    data () {
      return {
        show: true,
        loadedRatio: 0,
        page: 1,
        numPages: 0,
        rotate: 0,
        terminosCliente: null
      }
    },
    methods: {
      get_mantenedores(){
				let db = firebase.firestore()
				let self = this
				db.collection("mantenedores").doc("mantenedores").get().then(function(doc) {
						if (doc.exists) {
                self.terminosCliente = doc.data().terminos_y_condiciones_c
								// self.mantenedores = doc.data()
						} else {
								// doc.data() will be undefined in this case
								console.log("No such document!");
						}
				}).catch(function(error) {
						console.log("Error getting document:", error);
        });
        //console.log(self.mantenedores)
			},
      next(){
        this.page < 10 ? this.page++ : false
      },
      previous(){
        this.page > 1 ? this.page-- : false
      }
    }
}
</script>